module.exports = __webpack_public_path__ + "fonts/summernote.f4a47ce9.eot";